import { request } from "@/utils/request";
import { axios5Enum } from "./enum";

const FEST_URL = axios5Enum[process.env.VUE_APP_API_ENV];

/**
 * 舱单发送记录
 */

export const getShFileSendRecord = (data) => {
    return request("/hymanifestshhead/fcw/showlist", "post", data, {
        baseURL: FEST_URL,
    });
};

/**
 * 发送上海舱单补充信息
 * @param {String} billno
 * @param {String} remark
 * @param {String} uuid
 * @param {String} uuid
 */
export const sendShManifestExtraInfo = (data) => {
    return request(
        "/hymanifestshhead/fcw/fcwmanifestData",
        "post",
        data,
        {
            baseURL: FEST_URL,
        },
        true,
    );
};

/**
 * 导出舱单excel
 * @param {Number} id
 */
export const exportShManifestExcel = (param) => {
    return request(
        "/hymanifestshhead/fcw/exportexcel",
        "get",
        param,
        {
            responseType: "blob",
            baseURL: FEST_URL,
        },
    );
};

/**
 * 获取海管家船公司和船代(已弃用)
 */
export const getShipCompanyAndAgent = () => {
    return request("/hymanifestshhead/fcw/getHaiGuanJiaDict", "get", "", {
        baseURL: FEST_URL,
    });
};

/**
 * 获取船代数据
 */
export const getShipAgent = () => {
    return request("/hymanifestshhead/fcw/getShipAgencyList", "get", "", {
        baseURL: FEST_URL,
    });
};

/**
 * 获取船公司数据
 */
export const getShipCompany = () => {
    return request(
        "/hymanifestshhead/fcw/getShipCompanyList",
        "get",
        "",
        { baseURL: FEST_URL },
    );
};

export const addFastRemarkResquest = (data) => {
    return request("/manifestUserRemarkTags/save", "post", data, {
        baseURL: FEST_URL,
    });
};
